import React from 'react'

import type { UserRole } from '@/types'
import { addSpacesToPascalCase } from '@/services/helpers'

type ShareLoanListNameCellProps = {
	row: UserRole
}

const ShareLoanListNameCell = ({
	row: { user },
}: ShareLoanListNameCellProps) => {
	const { name, role } = user

	return (
		<div>
			<p className="font-medium">{name}</p>
			<p className="text-sm text-gray-500">
				{addSpacesToPascalCase(role)}
			</p>
		</div>
	)
}

export default ShareLoanListNameCell
